import { Dispatch, SetStateAction, useEffect, useMemo, useState } from "react";
import { Input } from "@/shared/components/atoms/Input";
import TableListTrain from "@/shared/components/organisms/TableListTrain";
import { useNavigate } from "react-router-dom";
import PreviewRoutine from "./PreviewRoutine";
import { AnimatePresence } from "framer-motion";
import {
  useAssignUserMutation,
  useDeleteRoutineMutation,
  useGtePlanForBranchQuery,
} from "../api/user-active-plan.api";
import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import { t } from "i18next";
import { toasts } from "@/shared/utils/toasts";
import { DeleteModal } from "@/shared/components/organisms/DeleteModal";
import { useSelector } from "react-redux";
import { selectUser } from "@/app/auth/auth.slice";

type Props = {
  user_id: number;
  openModalTrainingPlan: boolean;
  setOpenNewPlanTraining: Dispatch<SetStateAction<boolean>>;
  setOpenModalTrainingPlan: Dispatch<SetStateAction<boolean>>;
};

export default function SearchPlanComponent({
  user_id,
  openModalTrainingPlan,
  setOpenNewPlanTraining,
  setOpenModalTrainingPlan,
}: Props | any) {
  const currentUser = useSelector(selectUser);

  const taringPlaning = useGtePlanForBranchQuery({
    branchId: currentUser?.branch?.id,
  });

  const [assignUser] = useAssignUserMutation();
  const [deleteRoutine] = useDeleteRoutineMutation();
  const [confirmDeleteModal, setConfirmDeleteModal] = useState<any>({
    isOpen: false,
    id: null,
  });
  const [filterText, setFilterText] = useState("");
  const [filteredRoutines, setFilteredRoutines] = useState(taringPlaning?.data);
  const [previewRoutine, setPreviewRoutine] = useState<any>({
    id: null,
    state: false,
    name: null,
  });

  const capitalizeFirstLetter = (str: string) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const navigate = useNavigate();

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchText = e.target.value;
    setFilterText(searchText);
    const filteredData = taringPlaning?.data?.filter((routine: any) => {
      return routine?.name?.toLowerCase()?.includes(searchText?.toLowerCase());
    });
    setFilteredRoutines(filteredData);
  };

  console.log("taringPlaning", taringPlaning?.data);

  useEffect(() => {
    if (taringPlaning?.data) {
      setFilteredRoutines(taringPlaning?.data);
    }
  }, [taringPlaning?.data]);

  const handleCloseModal = () => {
    // Reiniciamos el estado de la previsualización
    setPreviewRoutine({
      id: null,
      state: false,
      name: null,
    });
    // Cerramos el modal principal
    setOpenModalTrainingPlan(false);
  };

  const OptionsBrandedActiveFee = useMemo(
    () => [
      {
        id: 1,
        title: t("trainingPlan.viewPlan"),
        description: t("trainingPlan.viewPlanDescription"),
        function: ({ id, routine }: any) => {
          setPreviewRoutine({
            id,
            state: true,
            name: routine.plan,
          });
        },
      },
      {
        id: 2,
        title: t("trainingPlan.duplicatePlan"),
        description: t("trainingPlan.duplicatePlanDescription"),
        function: ({ id }: any) => {
          navigate(`/admin/user/p-customize/edit?id=${id}&user_id=${user_id}`);
        },
      },
      {
        id: 3,
        title: t("trainingPlan.assignPlan"),
        description: t("trainingPlan.assignPlanDescription"),
        function: async ({ id }: { id: number }) => {
          try {
            const result = await assignUser({
              data: {
                p_customize_id: id,
                user_id: user_id,
                assigned_by_id: user_id,
              },
            }).unwrap();

            if (result) {
              toasts.info(
                t("general.perfect"),
                t("trainingPlan.planAssignedSuccess")
              );
            }
          } catch (error) {
            toasts.warning(
              t("trainingPlan.errorAssigningPlan"),
              t("trainingPlan.errorAssigningPlanDescription")
            );
            console.error(error);
          }
        },
      },
      {
        id: 4,
        title: t("trainingPlan.editPlan"),
        description: t("trainingPlan.editPlanDescription"),
        function: ({ id }: { id: number }) =>
          navigate(
            `/admin/user/p-customize/edit?id=${id}&edit=true&user_id=${user_id}&load=true`
          ),
      },
      {
        id: 5,
        title: t("trainingPlan.deletePlan"),
        description: t("trainingPlan.deletePlanDescription"),
        function: ({ id }: { id: number }) => {
          setConfirmDeleteModal({
            isOpen: true,
            id,
          });
        },
      },
    ],
    []
  );

  return (
    <DialogCreate
      tittleButtonCreate={t("general.create")}
      onClose={handleCloseModal}
      isLoading={false}
      acceptDisabled={false}
      cancelDisabled={false}
      footer={false}
      dialogWidth="max-w-5xl"
      open={openModalTrainingPlan}
      setOpen={setOpenNewPlanTraining}
      tittle={
        previewRoutine.state ? previewRoutine?.name : t("trainingPlan.plans")
      }
      tittleButtonCancel={t("general.cancel")}
      onBack={
        previewRoutine.state
          ? () =>
              setPreviewRoutine({
                id: null,
                state: false,
                name: null,
              })
          : undefined
      }
      OnclickCancel={() => {
        setOpenModalTrainingPlan(false);
      }}
    >
      <div className="w-full px-5">
        <section className="mt-6">
          <div className="space-y-4">
            <AnimatePresence>
              {previewRoutine.state ? (
                <>
                  <PreviewRoutine
                    id={previewRoutine.id}
                    user_id={user_id}
                    setPreviewRoutine={setPreviewRoutine}
                  />
                </>
              ) : (
                <>
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div className="w-full sm:w-auto">
                      <Input
                        type="text"
                        placeholder={t("trainingPlan.searchPlan")}
                        value={filterText}
                        onChange={handleFilterChange}
                        className="w-full sm:w-64"
                      />
                    </div>
                  </div>
                  <TableListTrain
                    titleBrandedActiveFee={t("trainingPlan.actions")}
                    training={filteredRoutines?.map((routine: any) => ({
                      id: routine.id,
                      name: routine.name,
                      description: capitalizeFirstLetter(
                        routine?.objective?.toLowerCase()
                      ),
                      period: routine?.period,
                      infoPage: {
                        description: routine?.description,
                        date: routine?.created_at,
                      },
                    }))}
                    OptionsBrandedActiveFee={OptionsBrandedActiveFee}
                  />
                </>
              )}
            </AnimatePresence>
          </div>
        </section>
      </div>
      <DeleteModal
        isOpen={confirmDeleteModal?.isOpen}
        onClose={() => setConfirmDeleteModal({ isOpen: false, id: null })}
        onDelete={async () => {
          try {
            await deleteRoutine({
              data: { id: confirmDeleteModal?.id },
            });
          } catch (error) {
            console.error(error);
          }
        }}
        itemName={t("trainingPlan.plan")}
      />
    </DialogCreate>
  );
}
